<template>
  <el-row>
    <el-col :span="24">
      <el-form-item label="列数组" prop="cols">
        <el-tag v-for="(col, index) in cols" :key="index" closable class="left-pad" @close="delCol(index)"
          >{{ col.name }}<span v-if="col.field">[{{ col.field }}]</span></el-tag
        >
        <el-input type="text" placeholder="请输入列（格式：列名|字段名)" v-model.trim="colName" size="small" v-on:keyup.enter.native="addCol"><el-button slot="append" @click="addCol">添加</el-button></el-input>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    props: {
      value: Object,
    },
    data() {
      return {
        colName: null,
      };
    },
    computed: {
      cols() {
        let cols = [];
        if (this.value && this.value.cols) {
          cols = JSON.parse(this.value.cols);
        }
        return cols;
      },
    },
    methods: {
      addCol() {
        let cols = this.$utils.Obj.clone(this.cols);
        let name = this.colName;
        let field = null;
        if (this.colName.indexOf("|") >= 0) {
          name = this.colName.split("|")[0];
          field = this.colName.split("|")[1];
        }
        cols.push({ name: name, field: field });
        this.value.cols = JSON.stringify(cols);
        this.colName = null;
      },
      delCol(idx) {
        let cols = this.$utils.Obj.clone(this.cols);
        cols.splice(idx, 1);
        this.value.cols = JSON.stringify(cols);
      },
    },
  };
</script>
